
import Transformer from './../transformer'
import { assetURL, objectToForm } from '@/utils'

const imagePlaceholder = require('@/assets/images/image_placeholder.jpg')

export default class SecurityPhotoTransformer extends Transformer {
  static fetch({ id, photo, small_picture, reason, work_plan_real, date, is_active }) {
    const smallPhoto = small_picture !== '' ? assetURL(small_picture) : imagePlaceholder
    const rejected = !is_active
    return {
      id,
      reason,
      reasonId: reason.id,
      photo: assetURL(photo),
      smallPhoto,
      workPlanReal: work_plan_real,
      date,
      isRejected: rejected,
    }
  }

  static send({ reasonId, photo, workPlanReal }) {
    return objectToForm({
      reason: reasonId,
      photo,
      work_plan_real: workPlanReal,
    })
  }
}


// WEBPACK FOOTER //
// ./src/transformers/workPlan/securityPhoto.js